import { mergeDeep } from "../../../../utils/Helper";
//import { validations } from "./Custody";

export const defaultState = () => ({
  event:{
    id: "0",
    CorporateEventType: "",
    Date: "0000-00-00",
    name: "",
    CurrencyId: "0",
    CurrencyISO: '',
    "AssetId": "0",
    "AssetName": "",
    "AssetTicker": "",
    "CorporateEventSplitFrom": 0,
    "CorporateEventSplitTo": 0,
    "CorporateEventExDividendDate": "0000-00-00",
    "Status": "",
    "CorporateEventSettlementCurrency": 0,
    "CorporateEventCommissionCurrency": 0,
    "CorporateEventFX": 0.00000000,
    "CorporateEventCommissionFX": 0.00000000,
    "CorporateEventTaxCurrency": '',
    "CorporateEventTaxFX": 0.00000000,
    "CorporateEventIsCovered": false,
    "CorporateEventIsCoverable": false,
    Account : [
      {
      "BasicAccountId": "0",
      "BasicAccountName": "",
      "EventBalanceType": "",
      "EventAccountAmount": "0.0000",
    Debit : [{
            "EventAccountFootprintId": "0",
            "EventAccountDebitCreditVolume": "0.00000000",
            "EventAccountIsCurrency": false,
            "EventAccountSecurityId": "0",
            "EventAccountTicker": "",
            "EventAccountIsCommission": false,
            "EventAccountIsTax": false,
            "EventAccountIsWithholding": false
    }],
    Credit : [{
      "EventAccountFootprintId": "0",
      "EventAccountDebitCreditVolume": "0.00000000",
      "EventAccountIsCurrency": false,
      "EventAccountSecurityId": "0",
      "EventAccountTicker": "",
      "EventAccountIsCommission": false,
      "EventAccountIsTax": false,
      "EventAccountIsWithholding": false
}]
  }
    ]
  },
//   clearingHouseItem:{
//     clearingHouseId:0,
//     clearingHouseSettlementInstructions:'',
//     clearingHouseDefault:false,
//     clearingHouseCode:'',
//     name:''
//   },
//   fields: {
//     readonly: {},
//     errors:{}
//   },
//   buttons: {
//     confirm: {
//       loading: false
//     }
//   },
//   editClearingHouse:false,
//   editClearingHouseId:false,
//   saveEditClearingHouseId:0,
//   saveEditClearingHouseCode:0,
//   initialized:true,
//   buttons: {
//     confirm: {
//       loading: false
//     }
//   },
//   error:true,
//   errors: {
//     name:false,
//     currencyNumber:false,
//     feeSchema:false,
//     description:false
//   },
//   message:'',
//   sentAuthorization:false
})

export const EventSimpleReducer = (state, action) => {
  switch (action.type) {
    case 'SET_EVENT':
        return InitializeValues(state, action);
    case 'EDIT_CLEARING_HOUSE':
        return editClearingHouse(state, action);
    case 'CLEARING_HOUSES_FIELDS':
        return processChangeClearingHousesFields(state, action.fields);
    case 'CLOSE_CLEARING_HOUSE':
      return closeClearingHouse(state);
    case 'ADD_CLEARING_HOUSE':
      return AddClearingHouses(state, action)
    case 'EDIT_CLEARING_HOUSE_ID':
      return EditClearingHouseId(state, action);
    case 'SAVE_EDIT_CLEARING_HOUSE':
        return SaveEditClearingHouse(state, action);
    case 'INITIALIZE_VALUES':
        return InitializeValues(state, action);
    case 'CHANGE_FIELDS_ACCOUNT_TYPE':
        return ChangeAccountType(state, action.fields);
    case 'UPDATE_BUTTONS':
        return processUpdateButtons(state, action.buttons);
    case 'VALIDATE_FIELDS':
        return validateForm(state);
    case 'SENT_AUTHORIZATION':
        return SentAuthorization(state,action);
    case 'RESET_CLOSE':
        return ResetClose(state, action);
    default:
      return state;
  }
}

// export const initialize = (props) => {
//     return (initialState) => {
//       return {
//         ...initialState,
//       }
//     }
// }

// export function editClearingHouse(state, props){
//   const {editClearingHouse, counterparty} = state;
//   return mergeDeep(
//     {...state},
//     {
//       editClearingHouse:true,
//       editClearingHouseId:false,
//       clearingHouseItem:{
//         clearingHouseCode:0,
//         name:props.clearingHouses[0].name,
//         clearingHouseId:props.clearingHouses[0].id,
//         clearingHouseSettlementInstructions:'',
//         clearingHouseDefault:false
//       }
//     }
//   )
// }

// function processChangeClearingHousesFields(state, fields) {
//   const errors = Object.keys(fields)
//     .reduce((f, name) => {
//       f[name] = undefined;
//       return f;
//     }, {});

//     return mergeDeep(
//       { ...state },
//       {
//         clearingHouseItem:{
//           ...fields
//         },
//         fields: {
//           errors
//         },
//       }
//     );
// }

// function processChangeFields(state, fields) {
//     const errors = Object.keys(fields)
//       .reduce((f, name) => {
//         f[name] = undefined;
//         return f;
//       }, {});
  
//       return mergeDeep(
//         { ...state },
//         {
//         custody: {
//             ...fields
//             },
//         fields: {
//             errors
//         },
//         }
//       );
//   }

//   function ChangeAccountType(state, fields) {
//     var isProp = false
//     if (fields.accountType==2){
//       isProp=true
//     }
//       return mergeDeep(
//         { ...state },
//         {
//         custody: {
//             accountType:fields.accountType,
//             isProp:isProp
//             }
//         }
//       );
//   }

//   export function closeClearingHouse(state){
//     const {editClearingHouse} = state;
//     return mergeDeep(
//       {...state},
//       {
//         editClearingHouse:false,
//         editClearingHouseId:false,
//         clearingHouseItem:{
//           clearingHouseCode:0,
//           name:'',
//           clearingHouseId:0,
//           clearingHouseSettlementInstructions:'',
//           clearingHouseDefault:false
//         }
//       }
//     )
//   }

//   export function AddClearingHouses(state, action){
//     const {counterparty, fields, clearingHouseItem, clearingHouses, editClearingHouse} = state;
//     var name=''
//     for(var j=0; j<action.clearingHouses.length; j++){
//       if (action.clearingHouses[j].id ==  clearingHouseItem.clearingHouseId){
//         name = action.clearingHouses[j].name
//       }
//     }
//     var clearingHouse={
//       clearingHouseId:clearingHouseItem.clearingHouseId,
//       clearingHouseSettlementInstructions:clearingHouseItem.clearingHouseSettlementInstructions,
//       clearingHouseDefault:clearingHouseItem.clearingHouseDefault,
//       clearingHouseCode:clearingHouseItem.clearingHouseCode,
//       name:name
//     }
//     var custody = {...state.custody, clearingHouse:[...state.custody.clearingHouse, clearingHouse]}
//     return mergeDeep(
//       {...state},
//       {
//         custody:custody,
//         editClearingHouse:false,
//         editClearingHouseId:false
//       }
//     )
//   }

//   function EditClearingHouseId(state, c){
//     var clear={
//       clearingHouseId:0,
//       clearingHouseSettlementInstructions:'',
//       clearingHouseDefault:false,
//       clearingHouseCode:'',
//       name:''
//     }
//     for(var i=0; i<state.custody.clearingHouse.length;i++){
//       if (state.custody.clearingHouse[i].clearingHouseId == c.c.clearingHouseId && state.custody.clearingHouse[i].clearingHouseCode == c.c.clearingHouseCode){
//         clear={
//           clearingHouseCode:state.custody.clearingHouse[i].clearingHouseCode,
//           name:state.custody.clearingHouse[i].name,
//           clearingHouseId:state.custody.clearingHouse[i].clearingHouseId,
//           clearingHouseSettlementInstructions:state.custody.clearingHouse[i].clearingHouseSettlementInstructions,
//           clearingHouseDefault:state.custody.clearingHouse[i].clearingHouseDefault
//         }
//       }
//     }
//     return mergeDeep(
//       {...state},
//       {editClearingHouseId:true,
//       clearingHouseItem:clear,
//       saveEditClearingHouseId:c.c.clearingHouseId,
//       saveEditClearingHouseCode:c.c.clearingHouseCode
//       }
//     )
//   }

//   export function SaveEditClearingHouse(state, action){
//     const {counterparty, fields, clearingHouseItem, saveEditClearingHouseId, saveEditClearingHouseCode, errors} = state;
//     var name=""
//     var clearing = state.custody.clearingHouse
//     for(var i=0; i<clearing.length;i++){
//       if (clearing[i].clearingHouseId == saveEditClearingHouseId && clearing[i].clearingHouseCode == saveEditClearingHouseCode){
//         for(var j=0; j<action.clearingHouses.length; j++){
//           if (action.clearingHouses[j].id ==  clearingHouseItem.clearingHouseId){
//             name = action.clearingHouses[j].name
//           }
//         }
//         clearing[i]={
//           clearingHouseCode:clearingHouseItem.clearingHouseCode,
//           name:name,
//           clearingHouseId:clearingHouseItem.clearingHouseId,
//           clearingHouseSettlementInstructions:clearingHouseItem.clearingHouseSettlementInstructions,
//           clearingHouseDefault:clearingHouseItem.clearingHouseDefault
//         }
//       }
//     }
//     var custody={...state.custody, clearingHouse:clearing}
//     return mergeDeep(
//       {...state},
//       {
//         clearingHouses:custody,
//         editClearingHouse:false,
//         editClearingHouseId:false,
//         saveEditClearingHouseId:0,
//         saveEditClearingHouseCode:0,
//       }
//     )
//   }

  export function InitializeValues(state, action){
    // const {editClearingHouse} = state;
    // var entity=0
    // var currency=0
    // var account=0
    // if (action.custodianEntity.length>0){
    //   entity=action.custodianEntity[0].id
    // }
    // if (action.currencies.length>0){
    //   currency=action.currencies[0].currencyId
    // }
    // if (action.imputableAccounts.length>0){
    //   account=action.imputableAccounts[0].id
    // }
    return mergeDeep(
      {...state},
      {
        event: action.event
      } 
        
      
    )
  }

//   export function processUpdateButtons(state, buttons) {
//     return mergeDeep(
//       {...state},
//       {
//         buttons
//       }
//     )
//   }
  
//   export function validateForm(state) {
//     var name = false
//     var feeSchema = false
//     var description = false
//     var currencyNumber = false
//     if (state.custody.name == ''){
//       name=true
//     }
//     if (state.custody.description == ''){
//       description = true
//     }
//     if (state.custody.feeSchema ==''){
//       feeSchema = true
//     }
//     if (state.custody.currencyNumber == ''){
//       currencyNumber =true
//     }
//     var errors={
//       name:name,
//       description:description,
//       feeSchema:feeSchema,
//       currencyNumber:currencyNumber
//     }
//     return mergeDeep(
//       {...state},
//       {
//         errors:errors,
//       }
//     )
//   }

//   export function validateErr(state) {
//     var error = false
//     if (state.custody.name == ''){
//       error=true
//     }
//     if (state.custody.description == ''){
//       error=true
//     }
//     if (state.custody.feeSchema ==''){
//       error=true
//     }
//     if (state.custody.currencyNumber == ''){
//       error=true
//     }
//     return error
//   }  

//   export function SentAuthorization(state, response){
//     var message=""
//     if (response.response.result.Code == 200){
//       message="Custody sent for authorization"
//     }else{
//       message=response.response.result.Description
//     }
//     var button={
//       confirm:{
//         loading:false
//       }
//     }
//     return mergeDeep(
//       {...state},
//       {
//       sentAuthorization:true,
//       buttons:button,
//       message:message
//       }
//     )
//   }

//   export function ResetClose(state, action){
//     action.onClickClose()
//     return mergeDeep(
//       {...state},
//       {
//         custody:{
//           name:'',
//           entityId:0,
//           custodiesCash:false,
//           custodiesValues:false,
//           description:'',
//           feeSchema:'',
//           currencyId:0,
//           isProp:false,
//           currencyNumber:'',
//           currencyImputableAccount:0,
//           isLocalBank:false,
//           clearingHouse:[],
//           accountType:1
//         },
//         clearingHouseItem:{
//           clearingHouseId:0,
//           clearingHouseSettlementInstructions:'',
//           clearingHouseDefault:false,
//           clearingHouseCode:'',
//           name:''
//         },
//         fields: {
//           readonly: {},
//           errors:{}
//         },
//         buttons: {
//           confirm: {
//             loading: false
//           }
//         },
//         editClearingHouse:false,
//         editClearingHouseId:false,
//         saveEditClearingHouseId:0,
//         saveEditClearingHouseCode:0,
//         initialized:true,
//         buttons: {
//           confirm: {
//             loading: false
//           }
//         },
//         error:true,
//         errors: {
//           name:false,
//           currencyNumber:false,
//           feeSchema:false,
//           description:false
//         },
//         message:'',
//         sentAuthorization:false
//       }
//     )
//   }